<template>
  <div>
    <Header></Header>

    <div class="container">
      <h2 class="font-saira-condensed my-5 font-weight-bolder">Artists</h2>

      <div class="artist-lists d-flex justify-content-center mb-5">
        <ul class="font-saira-condensed" v-for="artist in artists_data" :key="artist.key">
          <li @mouseenter="mouseover(artist.key)">{{artist.name}}</li>
        </ul>
      </div>

      <img :src="artist_cover" class="img-fluid" alt="artist-cover">

      <div class="mt-3 mt-lg-5" v-html="this.profile">

      </div>

      <Footer></Footer>
    </div>
  </div>
</template>

<script>
  import Header from "@/components/Header";
  import Footer from "@/components/Footer";

  export default {
    name: 'app',
    data() {
      return {
        artist_cover: require('@/assets/img/artists/artist_default.jpg'),
        profile: null,
        artists_data: [
          { key: "adsr", name: "ADSR" },
          { key: "koken", name: "KOKEN" },
          { key: "tozy", name: "Tozy" },
        ]
      }
    },
    components: {
      Footer,
      Header
    },
    methods: {
      mouseover(artist_name) {
        this.artist_cover = require('@/assets/img/artists/' + artist_name + '.jpg');
      }
    },
  }
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Noto+Sans+JP&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Righteous&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Saira+Condensed&display=swap');

  body {
    font-family: 'Noto Sans JP', sans-serif;
    line-height: 2;
    width: 100%;
    height: 100vh;
    background-color: #000 !important;
    color: #fff !important;
  }

  h2 {
    position: relative;
    top: 0;
    left: -100%;
    width: 170%;
    padding-left: 100%;
    font-weight: bold;
    padding-top: 1rem;
    padding-bottom: 1rem;
    background: linear-gradient(to right, #fff 50%, transparent);;
    color: #000;
  }

  .artist-lists ul {
    font-size: 1.5rem;
    display: inline-block;
    padding: 0;
    margin: 0;
  }

  .artist-lists li {
    list-style: none;
  }

  .artist-lists li {
    margin-right: 1rem;
  }


  /* Fonts */
  .font-righteous {
    font-family: 'Righteous', cursive;
  }

  .font-saira-condensed {
    font-family: 'Saira Condensed', sans-serif;
  }

  /* z-index */
  .z-index-9999 {
    z-index: 9999;
  }
</style>
